import authApi from './authApi'
import contactUsApi from './contactUsApi';
import registerApi from './registerApi';
import membersApi from './membersApi';
import generalApi from './generalApi';
import pagesApi from './pagesApi';
import slotsApi from './slotsApi';


export {
	authApi,
	contactUsApi,
	registerApi,
	membersApi,
	generalApi,
	pagesApi,
	slotsApi
}